import React, { useState } from "react";
import axios from "axios";

const Delete = ({ itemId, apiEndpoint, onDelete, onClose, deleteMessage }) => {
  const [loading, setLoading] = useState(false);

  const handleDelete = async () => {
    setLoading(true);
    try {
      const response = await axios.delete(`${apiEndpoint}/${itemId}`);
      if (response.status === 200) {
        onDelete(); // Notify parent to refresh data
        onClose();  // Close modal after success
      } else {
        alert("Failed to delete the item. Please try again.");
      }
    } catch (error) {
      alert("An error occurred while deleting the item.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h2 className="text-xl font-semibold">Confirm Deletion</h2>
      <p className="my-4">{deleteMessage}</p>
      <div className="flex justify-end gap-4">
        <button
          onClick={handleDelete}
          className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600 disabled:bg-gray-400"
          disabled={loading}
        >
          {loading ? "Deleting..." : "Yes, Delete"}
        </button>
        <button
          onClick={onClose}
          className="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600"
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

export default Delete;
